<template>
  <div>
    Icons Page
  </div>
</template>

<script>
export default {
  name: 'Icons',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// Icons.vue?b50f7fc6